import { render, staticRenderFns } from "./WorkflowPrimitive.vue?vue&type=template&id=2dbc9a94&"
import script from "./WorkflowPrimitive.vue?vue&type=script&lang=js&"
export * from "./WorkflowPrimitive.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowPrimitive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports